import React from 'react';
import { Navigate } from 'react-router-dom';
import App from './../app.jsx';

import DashboardV1 from './../pages/dashboard/dashboard-v1.jsx';
import DashboardV2 from './../pages/dashboard/dashboard-v2.jsx';
import DashboardV3 from './../pages/dashboard/dashboard-v3.jsx';
import DashboardV4 from './../pages/dashboard/dashboard-v4.jsx';
import AIChat from './../pages/ai/ai-chat.jsx';
import AIImageGenerator from './../pages/ai/ai-image-generator.jsx';
import EmailInbox from './../pages/email/email-inbox.jsx';
import EmailCompose from './../pages/email/email-compose.jsx';
import EmailDetail from './../pages/email/email-detail.jsx';
import EmailSystem from './../pages/email/email-system.jsx';
import EmailNewsletter from './../pages/email/email-newsletter.jsx';
import AuthClassicSignIn from './../pages/auth/auth-classic-sign-in.jsx';
import AuthClassicSignUp from './../pages/auth/auth-classic-sign-up.jsx';
import AuthClassicResetPassword from './../pages/auth/auth-classic-reset-password.jsx';
import AuthClassicNewPassword from './../pages/auth/auth-classic-new-password.jsx';
import AuthClassicLockScreen from './../pages/auth/auth-classic-lock-screen.jsx';
import AuthClassicEmailSent from './../pages/auth/auth-classic-email-sent.jsx';
import AuthWithBoxSignIn from './../pages/auth/auth-with-box-sign-in.jsx';
import AuthWithBoxSignUp from './../pages/auth/auth-with-box-sign-up.jsx';
import AuthWithBoxResetPassword from './../pages/auth/auth-with-box-reset-password.jsx';
import AuthWithBoxNewPassword from './../pages/auth/auth-with-box-new-password.jsx';
import AuthWithBoxLockScreen from './../pages/auth/auth-with-box-lock-screen.jsx';
import AuthWithBoxEmailSent from './../pages/auth/auth-with-box-email-sent.jsx';
import AuthWithImageSignIn from './../pages/auth/auth-with-image-sign-in.jsx';
import AuthWithImageSignUp from './../pages/auth/auth-with-image-sign-up.jsx';
import AuthWithImageResetPassword from './../pages/auth/auth-with-image-reset-password.jsx';
import AuthWithImageNewPassword from './../pages/auth/auth-with-image-new-password.jsx';
import AuthWithImageLockScreen from './../pages/auth/auth-with-image-lock-screen.jsx';
import AuthWithImageEmailSent from './../pages/auth/auth-with-image-email-sent.jsx';
import AuthFullScreenSignIn from './../pages/auth/auth-full-screen-sign-in.jsx';
import AuthFullScreenSignUp from './../pages/auth/auth-full-screen-sign-up.jsx';
import AuthFullScreenResetPassword from './../pages/auth/auth-full-screen-reset-password.jsx';
import AuthFullScreenNewPassword from './../pages/auth/auth-full-screen-new-password.jsx';
import AuthFullScreenLockScreen from './../pages/auth/auth-full-screen-lock-screen.jsx';
import AuthFullScreenEmailSent from './../pages/auth/auth-full-screen-email-sent.jsx';
import AuthCoverBgSignIn from './../pages/auth/auth-cover-bg-sign-in.jsx';
import AuthCoverBgSignUp from './../pages/auth/auth-cover-bg-sign-up.jsx';
import AuthCoverBgResetPassword from './../pages/auth/auth-cover-bg-reset-password.jsx';
import AuthCoverBgNewPassword from './../pages/auth/auth-cover-bg-new-password.jsx';
import AuthCoverBgLockScreen from './../pages/auth/auth-cover-bg-lock-screen.jsx';
import AuthCoverBgEmailSent from './../pages/auth/auth-cover-bg-email-sent.jsx';
import HelperCSS from './../pages/helper/helper-css.jsx';
import FormElements from './../pages/form/form-elements.jsx';
import FormPlugins from './../pages/form/form-plugins.jsx';
import FormWizards from './../pages/form/form-wizards.jsx';
import TableElements from './../pages/table/table-elements.jsx';
import TablePlugins from './../pages/table/table-plugins.jsx';
import ChartJS from './../pages/chart/chart-js.jsx';
import ChartApex from './../pages/chart/chart-apex.jsx';
import Widget from './../pages/widget/widget.jsx';
import Landing from './../pages/landing/landing.jsx';
import Calendar from './../pages/calendar/calendar.jsx';
import Profile from './../pages/extra/extra-profile.jsx';
import Settings from './../pages/extra/extra-settings-page.jsx';
import Gallery from './../pages/gallery/gallery.jsx';

import PageStarter from './../pages/layout/page-starter.jsx';
import PageFullWidth from './../pages/layout/page-full-width.jsx';
import PageFixedFooter from './../pages/layout/page-with-fixed-footer.jsx';
import PageFullHeight from './../pages/layout/page-full-height.jsx';
import PageRightSidebar from './../pages/layout/page-with-right-sidebar.jsx';
import PageMinifiedSidebar from './../pages/layout/page-with-minified-sidebar.jsx';
import PageTwoSidebar from './../pages/layout/page-with-two-sidebar.jsx';
import PageMegaMenu from './../pages/layout/page-with-mega-menu.jsx';
import PageTopNav from './../pages/layout/page-with-top-nav.jsx';
import PageBoxedLayout from './../pages/layout/page-with-boxed-layout.jsx';
import PageMixedNav from './../pages/layout/page-with-mixed-nav.jsx';
import PageMixedNavBoxed from './../pages/layout/page-boxed-layout-with-mixed-nav.jsx';
import PageSearchSidebar from './../pages/layout/page-with-search-sidebar.jsx';
import PageHoverSidebar from './../pages/layout/page-with-hover-sidebar.jsx';
import PageWithFooter from './../pages/layout/page-with-footer.jsx';

import Timeline from './../pages/extra/extra-timeline.jsx';
import ComingSoon from './../pages/extra/extra-coming-soon.jsx';
import SearchResults from './../pages/extra/extra-search.jsx';
import Invoice from './../pages/extra/extra-invoice.jsx';
import ErrorPage from './../pages/extra/extra-error.jsx';
import ScrumBoard from './../pages/extra/extra-scrum-board.jsx';
import CookieBanner from './../pages/extra/extra-cookie-acceptance-banner.jsx';
import Orders from './../pages/extra/extra-orders.jsx';
import OrderDetails from './../pages/extra/extra-order-details.jsx';
import Products from './../pages/extra/extra-products.jsx';
import ProductDetails from './../pages/extra/extra-product-details.jsx';
import FileManager from './../pages/extra/extra-file-manager.jsx';
import PricingPage from './../pages/extra/extra-pricing-page.jsx';
import Messenger from './../pages/extra/extra-messenger-page.jsx';
import DataManagement from './../pages/extra/extra-data-management.jsx';

import PosCustomerOrder from './../pages/pos/customer-order.jsx';
import PosCounterCheckout from './../pages/pos/counter-checkout.jsx';
import PosKitchenOrder from './../pages/pos/kitchen-order.jsx';
import PosTableBooking from './../pages/pos/table-booking.jsx';
import PosMenuStock from './../pages/pos/menu-stock.jsx';

import UIGeneral from './../pages/ui/ui-general.jsx';
import UITypography from './../pages/ui/ui-typography.jsx';
import UITabsAccordion from './../pages/ui/ui-tabs-accordion.jsx';
import UIUnlimitedTabs from './../pages/ui/ui-unlimited-tabs.jsx';
import UIModalNotification from './../pages/ui/ui-modal-notification.jsx';
import UIWidgetBoxes from './../pages/ui/ui-widget-boxes.jsx';
import UIMediaObject from './../pages/ui/ui-media-object.jsx';
import UIButtons from './../pages/ui/ui-buttons.jsx';
import UIIconFontawesome from './../pages/ui/ui-icon-fontawesome.jsx';
import UIIconBootstrap from './../pages/ui/ui-icon-bootstrap.jsx';
import UIIconDuotone from './../pages/ui/ui-icon-duotone.jsx';
import UIIconSimpleLine from './../pages/ui/ui-icon-simple-line-icons.jsx';
import UIIconIonicons from './../pages/ui/ui-icon-ionicons.jsx';
import UILanguageFlag from './../pages/ui/ui-language-flag-icon.jsx';
import UISocialButtons from './../pages/ui/ui-social-buttons.jsx';

const route = (path, Component, props) => ({ path, element: <Component {...props} /> });
const authRoute = (path, Component) => route(path, Component);

const routes = [
	route('email/system', EmailSystem),
	route('email/newsletter', EmailNewsletter),
	{
		path: '*',
		element: <App />,
		children: [
			{ path: '', element: <Navigate to="/dashboard/v1" replace /> },
			route('dashboard/v1', DashboardV1),
			route('dashboard/v2', DashboardV2),
			route('dashboard/v3', DashboardV3),
			route('dashboard/v4', DashboardV4),
			route('ai/chat', AIChat),
			route('ai/image-generator', AIImageGenerator),
			route('email/inbox', EmailInbox),
			route('email/compose', EmailCompose),
			route('email/detail', EmailDetail),
			route('widget', Widget),
			route('ui/general', UIGeneral),
			route('ui/typography', UITypography),
			route('ui/tabs-accordions', UITabsAccordion),
			route('ui/unlimited-tabs', UIUnlimitedTabs),
			route('ui/modal-notification', UIModalNotification),
			route('ui/widget-boxes', UIWidgetBoxes),
			route('ui/media-object', UIMediaObject),
			route('ui/buttons', UIButtons),
			route('ui/icon-fontawesome', UIIconFontawesome),
			route('ui/icon-bootstrap', UIIconBootstrap),
			route('ui/icon-duotone', UIIconDuotone),
			route('ui/icon-simple-line-icons', UIIconSimpleLine),
			route('ui/icon-ionicons', UIIconIonicons),
			route('ui/language-flag-icon', UILanguageFlag),
			route('ui/social-buttons', UISocialButtons),
			route('form/elements', FormElements),
			route('form/plugins', FormPlugins),
			route('form/wizards', FormWizards),
			route('table/elements', TableElements),
			route('table/plugins', TablePlugins),
			route('pos/customer-order', PosCustomerOrder),
			route('pos/counter-checkout', PosCounterCheckout),
			route('pos/kitchen-order', PosKitchenOrder),
			route('pos/table-booking', PosTableBooking),
			route('pos/menu-stock', PosMenuStock),
			route('chart/js', ChartJS),
			route('chart/apex', ChartApex),
			route('map', Map),
			route('layout/starter', PageStarter),
			route('layout/fixed-footer', PageFixedFooter),
			route('layout/full-width', PageFullWidth),
			route('layout/right-sidebar', PageRightSidebar),
			route('layout/minified-sidebar', PageMinifiedSidebar),
			route('layout/two-sidebar', PageTwoSidebar),
			route('layout/full-height', PageFullHeight),
			route('layout/mega-menu', PageMegaMenu),
			route('layout/top-nav', PageTopNav),
			route('layout/boxed-layout', PageBoxedLayout),
			route('layout/mixed-nav', PageMixedNav),
			route('layout/mixed-nav-boxed-layout', PageMixedNavBoxed),
			route('layout/search-sidebar', PageSearchSidebar),
			route('layout/hover-sidebar', PageHoverSidebar),
			route('layout/with-footer', PageWithFooter),
			route('page/timeline', Timeline),
			route('page/coming-soon', ComingSoon),
			route('page/search-results', SearchResults),
			route('page/invoice', Invoice),
			route('page/404-error', ErrorPage),
			route('page/scrum-board', ScrumBoard),
			route('page/cookie-acceptance-banner', CookieBanner),
			route('page/orders', Orders),
			route('page/order-details', OrderDetails),
			route('page/products', Products),
			route('page/product-details', ProductDetails),
			route('page/file-manager', FileManager),
			route('page/pricing-page', PricingPage),
			route('page/messenger-page', Messenger),
			route('page/data-management', DataManagement),
			route('page/gallery', Gallery),
			route('landing', Landing),
			route('profile', Profile),
			route('calendar', Calendar),
			route('settings', Settings),
			route('helper', HelperCSS),
			authRoute('auth/classic/sign-in', AuthClassicSignIn),
			authRoute('auth/classic/sign-up', AuthClassicSignUp),
			authRoute('auth/classic/reset-password', AuthClassicResetPassword),
			authRoute('auth/classic/new-password', AuthClassicNewPassword),
			authRoute('auth/classic/lock-screen', AuthClassicLockScreen),
			authRoute('auth/classic/email-sent', AuthClassicEmailSent),
			authRoute('auth/with-box/sign-in', AuthWithBoxSignIn),
			authRoute('auth/with-box/sign-up', AuthWithBoxSignUp),
			authRoute('auth/with-box/reset-password', AuthWithBoxResetPassword),
			authRoute('auth/with-box/new-password', AuthWithBoxNewPassword),
			authRoute('auth/with-box/lock-screen', AuthWithBoxLockScreen),
			authRoute('auth/with-box/email-sent', AuthWithBoxEmailSent),
			authRoute('auth/with-image/sign-in', AuthWithImageSignIn),
			authRoute('auth/with-image/sign-up', AuthWithImageSignUp),
			authRoute('auth/with-image/reset-password', AuthWithImageResetPassword),
			authRoute('auth/with-image/new-password', AuthWithImageNewPassword),
			authRoute('auth/with-image/lock-screen', AuthWithImageLockScreen),
			authRoute('auth/with-image/email-sent', AuthWithImageEmailSent),
			authRoute('auth/full-screen/sign-in', AuthFullScreenSignIn),
			authRoute('auth/full-screen/sign-up', AuthFullScreenSignUp),
			authRoute('auth/full-screen/reset-password', AuthFullScreenResetPassword),
			authRoute('auth/full-screen/new-password', AuthFullScreenNewPassword),
			authRoute('auth/full-screen/lock-screen', AuthFullScreenLockScreen),
			authRoute('auth/full-screen/email-sent', AuthFullScreenEmailSent),
			authRoute('auth/cover-bg/sign-in', AuthCoverBgSignIn),
			authRoute('auth/cover-bg/sign-up', AuthCoverBgSignUp),
			authRoute('auth/cover-bg/reset-password', AuthCoverBgResetPassword),
			authRoute('auth/cover-bg/new-password', AuthCoverBgNewPassword),
			authRoute('auth/cover-bg/lock-screen', AuthCoverBgLockScreen),
			authRoute('auth/cover-bg/email-sent', AuthCoverBgEmailSent),
			{ path: '*', element: <Navigate to="/dashboard/v1" replace /> }
		]
	}
];

export default routes;
